import {
  FeatureName,
  PermissionValues as Permissions,
  useCurrentWorkspace,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { Colors } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';

import { AddButton } from '../../shared/components/addButton/addButton';
import { CreateGroupForm } from './createGroupForm';

export const GroupsToolbar = () => {
  const isCropCircleEnable = useIsFeatureEnabled(FeatureName.CropCircleRedesign);
  const { t } = useTranslation();
  const currentWorkspace = useCurrentWorkspace();

  if (isCropCircleEnable) {
    return currentWorkspace && (
      <ModalButton
        label={''}        
        customButton={(toggleVisibility) => (
          <AddButton
            onPress={() => toggleVisibility(true)}
          />
        )}
        requiredPermission={Permissions.workspace.create}
        containerStyle={styles.modalContainer}
        modalComponent={({ onComplete }) => {
          return (
            <CreateGroupForm
              onComplete={onComplete}
              workspaceId={currentWorkspace.id}
            />
          );
        }}
      />
    )
  }

  return (
    currentWorkspace && (
      <ModalButton
        label={t('groups.create.label')}
        icon="plus"
        requiredPermission={Permissions.workspace.create}
        containerStyle={styles.modalContainer}
        modalComponent={({ onComplete }) => {
          return (
            <CreateGroupForm
              onComplete={onComplete}
              workspaceId={currentWorkspace.id}
            />
          );
        }}
      />
    )
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    alignSelf: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 560,
    maxHeight: 193,
    borderRadius: 12,
    backgroundColor: Colors.primaryGrayBackground,
  },
  addButton: {
    padding: 0,
    margin: 0,
    height: 32,
    width: 32,
    minHeight: 32,
    minWidth: 32,
  },
});
